


































import { Component, Prop, Vue } from 'vue-property-decorator'
import Game from '../classes/game'
import GuesserControls from './GuesserControls.vue'

@Component({
  components: {
    GuesserControls
  }
})
export default class PuzzleStore extends Vue {
  @Prop() private game!: Game;
}
